/*!
 * Real-user Core Web Vitals RUM for onlinecompass.net.
 *
 * Uses the web-vitals library (https://github.com/GoogleChrome/web-vitals) to
 * collect FIELD INP, LCP and CLS from real visitors and send them to GA4.
 * This is the same measurement Google uses for ranking / CrUX — far more
 * trustworthy than lab TBT. Loaded as a deferred Vite module, so it adds
 * effectively no main-thread cost: it only observes performance entries and
 * reports once per pageview (on page hide / visibilitychange).
 *
 * In GA4: create custom dimensions on `metric_rating` and `metric_value` to
 * slice INP / LCP / CLS by route and by good / needs-improvement / poor.
 *
 * (CWV RUM was previously removed in 5d891c0; this re-adds just the reporting,
 *  as a zero-impact deferred module. To stop collecting: remove the @vite tag
 *  in Master.blade.php and this entry from vite.config.js.)
 */
import { onCLS, onINP, onLCP } from 'web-vitals';

function send({ name, delta, value, id, rating }) {
    if (typeof window.gtag !== 'function') return;
    // Google's documented CWV->GA4 recipe: CLS is scaled x1000 (it is a small
    // fraction); non_interaction:true so these do not skew engagement/bounce.
    window.gtag('event', name, {
        event_category: 'Web Vitals',
        event_label: id,
        value: Math.round(name === 'CLS' ? delta * 1000 : delta),
        metric_rating: rating,            // 'good' | 'needs-improvement' | 'poor'
        metric_value: Math.round(value),  // rounded ms (INP, LCP) or x1000 (CLS)
        non_interaction: true,
    });
}

onCLS(send);
onINP(send);
onLCP(send);
